package com.iregained.site.components.sections.product.styles

import com.iregained.site.theme.toSitePalette
import com.varabyte.kobweb.compose.css.Transition
import com.varabyte.kobweb.compose.css.TransitionTimingFunction
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.compose.ui.styleModifier
import com.varabyte.kobweb.silk.style.CssStyle
import com.varabyte.kobweb.silk.style.selectors.before
import com.varabyte.kobweb.silk.style.selectors.hover
import org.jetbrains.compose.web.css.Position
import org.jetbrains.compose.web.css.percent
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.css.s

val CollageImageStyle = CssStyle {
    base {
        Modifier.transition(
                Transition.of("filter", 0.5.s), Transition.of("transform", 0.5.s)
            )
            // Start desaturated to look clinical and serious
            .styleModifier { property("filter", "grayscale(50%)") }
    }
    hover {
        Modifier.scale(1.03) // Subtle interior zoom
            .styleModifier { property("filter", "grayscale(0%)") } // Pop to full color
    }
}

val KnowMoreLinkStyle = CssStyle {
    val palette = colorMode.toSitePalette()

    base {
        Modifier.position(Position.Relative).color(palette.brand.primary).transition(Transition.of("color", 0.3.s))
    }
    // The hidden underline resting state
    before {
        Modifier.content("").position(Position.Absolute).bottom((-4).px) // Sits just below the text
            .left(0.px).width(0.px)     // Starts at 0 width
            .height(2.px).backgroundColor(palette.brand.primaryHover)
            .transition(Transition.of("width", 0.3.s, TransitionTimingFunction.EaseOut))
    }
    // Color darkens slightly on hover
    hover {
        Modifier.color(palette.brand.primaryHover)
    }
    // The underline expands left-to-right on hover
    cssRule(":hover::before") {
        Modifier.width(100.percent)
    }
}